export type Locales = 'nl';
export type Language = (typeof languages)[number];
export const languages = ['nl'];

export const i18nConfig = {
    locales: ['nl'],
    defaultLocale: 'nl',
    prefixDefault: false,
};

export default i18nConfig;
